import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { wordpressClient } from "../App";
import { RefetchIntervals } from "../contants/RefetchIntervals";
import { WordpressPost } from "../types/wordpressTypes/wordpressPost";
import { useProcessWordpressPostData } from "./useProcessWordpressPostData";

export function useWordpressPostData() {
  const query = useMemo(() => ({ "tv-filter": "true" }), []);

  const { data: wordpressPosts } = useQuery({
    queryKey: ["posts"],
    queryFn: async () => {
      return wordpressClient.post().find(new URLSearchParams(query));
    },
    initialData: [],
    refetchInterval: RefetchIntervals.posts
  });

  const { data: wordpressKabelkrantCategories } = useQuery({
    queryKey: ["kabelkrantCategories"],
    queryFn: async () => {
      return wordpressClient.kabelkrantCategorie().dangerouslyFindAll();
    },
    initialData: [],
    refetchInterval: RefetchIntervals.categories
  });

  const filteredWordpressPosts = useMemo(() => wordpressPosts.filter((post) => post != null) as WordpressPost[], [wordpressPosts]);
  const { posts } = useProcessWordpressPostData(filteredWordpressPosts, wordpressKabelkrantCategories);

  return { posts, wordpressKabelkrantCategories };
}
